import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Checkbox,
    FormControlLabel,
    FormLabel,
    styled,
} from "@mui/material";
import { each, get } from "lodash";
import React from "react";
import { us_states_map } from "../utils/constants";
import { marketFilters } from "./constants";

const StyledMenuSectionTitle = styled("h4")({
    color: "#9e9e9e",
    fontSize: "13px",
    fontWeight: "600",
    textTransform: "uppercase",
    marginBottom: "5px",
});

const StyledAccordion = styled(Accordion)({
    margin: "0",
    borderTop: "1px solid #eeeeee",
});

const StyledAccordionSummary = styled(AccordionSummary)({
    minHeight: "0 !important",
    ".Mui-expanded": {
        margin: "0 !important",
        background: "#fafafa",
    },
    ".MuiAccordionSummary-content": {
        margin: "0",
        ".Mui-expanded": {
            margin: "0 !important",
            background: "#fafafa",
        },
    },
});

const StyledAccordionDetails = styled(AccordionDetails)({
    padding: "0 20px",
    borderTop: "1px solid #eeeeee",
});

const StyledCheckboxContainer = styled("div")({
    padding: "8px",
    width: "100%",
});

const StyledMicromarketContainer = styled("div")({
    padding: "8px",
    flexBasis: "50%",
    maxWidth: "50%",
    boxSizing: "border-box",
});

const StyledMicromarketWrapper = styled("div")({
    display: "flex",
    flexWrap: "wrap",
});

const StyledFormLabel = styled(FormLabel)({
    marginBottom: "10px",
    paddingLeft: "20px",
    paddingTop: "10px",
});

const MarketFilters = (props) => {
    const {
        handleSelectMarket,
        handleSelectMicromarket,
        handleSelectSubmarket,
        marketFilterExpansionPanels,
        searchCriteria,
        toggleMarketFilterExpansionPanel,
    } = props;

    const countMarketSubmarketsSelected = (searchCriteria, path) => {
        let count = 0;
        each(Object.keys(get(searchCriteria, `locationCriteria.markets.${path}`, {})), (key) => {
            if (get(searchCriteria, `locationCriteria.markets.${path}.${key}.selected`, false) === true) {
                count += 1;
            }
        });
        return count;
    };

    return (
        <div>
            <div>
                {Object.keys(marketFilters).map((stateCode) => {
                    return (
                        <React.Fragment key={stateCode}>
                            <StyledFormLabel component="legend">{us_states_map[stateCode]}</StyledFormLabel>
                            {Object.keys(marketFilters[stateCode]).map((market) => {
                                return (
                                    <div key={market} style={{ width: "100%" }}>
                                        <StyledAccordion expanded={get(marketFilterExpansionPanels, market, false)}>
                                            <StyledAccordionSummary
                                                expandIcon={
                                                    <ExpandMoreIcon
                                                        onClick={() => {
                                                            toggleMarketFilterExpansionPanel(market);
                                                        }}
                                                    />
                                                }
                                            >
                                                <div>
                                                    <div>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={get(
                                                                        searchCriteria,
                                                                        `locationCriteria.markets.${market}.selected`,
                                                                        false
                                                                    )}
                                                                    onChange={(e) =>
                                                                        handleSelectMarket(market, e.target.checked)
                                                                    }
                                                                    value={market}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={`${market} ${
                                                                countMarketSubmarketsSelected(searchCriteria, market) >
                                                                0
                                                                    ? `(${countMarketSubmarketsSelected(
                                                                          searchCriteria,
                                                                          market
                                                                      )})`
                                                                    : ""
                                                            }`}
                                                        />
                                                    </div>
                                                </div>
                                            </StyledAccordionSummary>
                                            <StyledAccordionDetails>
                                                <div>
                                                    <StyledCheckboxContainer>
                                                        <StyledMenuSectionTitle>
                                                            {market} Submarkets
                                                        </StyledMenuSectionTitle>
                                                    </StyledCheckboxContainer>
                                                    {Object.keys(marketFilters[stateCode][market]).map((submarket) => {
                                                        return (
                                                            <div key={submarket} style={{ width: "100%" }}>
                                                                <StyledAccordion
                                                                    expanded={get(
                                                                        marketFilterExpansionPanels,
                                                                        `${market}.${submarket}`,
                                                                        false
                                                                    )}
                                                                >
                                                                    <StyledAccordionSummary
                                                                        expandIcon={
                                                                            marketFilters[stateCode][market][submarket]
                                                                                .length > 0 ? (
                                                                                <ExpandMoreIcon
                                                                                    onClick={() => {
                                                                                        toggleMarketFilterExpansionPanel(
                                                                                            `${market}.${submarket}`
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                ""
                                                                            )
                                                                        }
                                                                    >
                                                                        <div>
                                                                            <div>
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={get(
                                                                                                searchCriteria,
                                                                                                `locationCriteria.markets.${market}.${submarket}.selected`,
                                                                                                false
                                                                                            )}
                                                                                            onChange={(e) =>
                                                                                                handleSelectSubmarket(
                                                                                                    market,
                                                                                                    submarket,
                                                                                                    e.target.checked
                                                                                                )
                                                                                            }
                                                                                            value={submarket}
                                                                                            color="primary"
                                                                                        />
                                                                                    }
                                                                                    label={`${submarket} ${
                                                                                        countMarketSubmarketsSelected(
                                                                                            searchCriteria,
                                                                                            `${market}.${submarket}`
                                                                                        ) > 0
                                                                                            ? `(${countMarketSubmarketsSelected(
                                                                                                  searchCriteria,
                                                                                                  `${market}.${submarket}`
                                                                                              )})`
                                                                                            : ""
                                                                                    }`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </StyledAccordionSummary>
                                                                    <StyledAccordionDetails>
                                                                        <div>
                                                                            <StyledCheckboxContainer>
                                                                                <StyledMenuSectionTitle>
                                                                                    {market} - {submarket} Micromarkets
                                                                                </StyledMenuSectionTitle>
                                                                            </StyledCheckboxContainer>
                                                                            <StyledMicromarketWrapper>
                                                                                {marketFilters[stateCode][market][
                                                                                    submarket
                                                                                ].map((micromarket) => {
                                                                                    return (
                                                                                        <StyledMicromarketContainer
                                                                                            key={micromarket}
                                                                                        >
                                                                                            <FormControlLabel
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={get(
                                                                                                            searchCriteria,
                                                                                                            `locationCriteria.markets.${market}.${submarket}.${micromarket}.selected`,
                                                                                                            false
                                                                                                        )}
                                                                                                        onChange={(e) =>
                                                                                                            handleSelectMicromarket(
                                                                                                                market,
                                                                                                                submarket,
                                                                                                                micromarket,
                                                                                                                e.target
                                                                                                                    .checked
                                                                                                            )
                                                                                                        }
                                                                                                        value={
                                                                                                            micromarket
                                                                                                        }
                                                                                                        color="primary"
                                                                                                    />
                                                                                                }
                                                                                                label={micromarket}
                                                                                            />
                                                                                        </StyledMicromarketContainer>
                                                                                    );
                                                                                })}
                                                                            </StyledMicromarketWrapper>
                                                                        </div>
                                                                    </StyledAccordionDetails>
                                                                </StyledAccordion>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </StyledAccordionDetails>
                                        </StyledAccordion>
                                    </div>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default MarketFilters;
